// MainStore.js
import { defineStore } from 'pinia';

export const useMainStore = defineStore('main', {
    state: () => ({
        hideConfigButton: true,
        isPinned: false,
        showConfig: false,
        sidebarType: "bg-white",
        mcolor: "",
        darkMode: false,
        isNavFixed: true,
        isAbsolute: false,
        showNavs: true,
        showSidenav: true,
        showNavbar: true,
        showFooter: true,
        showMain: true,
        layout: "default",
        topnavOpenMenu: null,
    }),
    actions: {
        toggleConfigurator() {
            this.showConfig = !this.showConfig;
        },
        sidebarMinimize() {
            let sidenav_show = document.querySelector("#app");
            if (this.isPinned) {
                sidenav_show.classList.add("g-sidenav-hidden");
                sidenav_show.classList.remove("g-sidenav-pinned");
                this.isPinned = false;
            } else {
                sidenav_show.classList.add("g-sidenav-pinned");
                sidenav_show.classList.remove("g-sidenav-hidden");
                this.isPinned = true;
            }
        },
        toggleSidebarColor(payload) {
            this.sidebarType = payload;
        },
        navbarFixed() {
            this.isNavFixed = !this.isNavFixed;
        },
        toggleDarkMode() {
            this.darkMode = !this.darkMode;
            if (this.darkMode) {
                document.body.classList.add("dark-version");
                document.documentElement.classList.add("dark-theme");
                document.documentElement.classList.add("dark-version");

            } else {
                document.body.classList.remove("dark-version");
                document.documentElement.classList.remove("dark-theme");
                document.documentElement.classList.remove("dark-version");
            }
            this.sidebarType = this.darkMode ? "bg-dark" : "bg-white";
        },
        setTopnavOpenMenu(menu) {
            this.topnavOpenMenu = this.topnavOpenMenu === menu ? null : menu;
        },
        closeTopnavMenu() {
            this.topnavOpenMenu = null;
        },
    },
    getters: {
    },
});
